import { Box, Typography } from "@mui/material";
import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  ReferenceManyField,
  ArrayField,
  ChipField,
  Datagrid,
  DateField,
  List,
  ReferenceField,
  SingleFieldList,
  TextField,
  EditButton,
  required,
  ImageField,
  Create,
  TabbedForm,
  FormTab,
  ArrayInput,
  SimpleFormIterator,
  Button,
  FormDataConsumer,
  useRecordContext,
  useListContext,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  NumberField,
} from "react-admin";
import { useNavigate } from "react-router";
import ArrayEditor from "../../../components/array/array.editor";
import DataGridExtended from "../../../components/list/data.grid.extended";
import AIFunctionEdit from "./AIFunctionEdit";
import AIFileEdit from "./AIFileEdit";
import { AIAssistantInstanceList } from "./AIAssistantInstance";
import { useEffect } from "react";
import ChatInterface from "../chat/ChatInterface";
import EmbedAgent from "../embed/EmbedAgent";

export const AIAssistantList = () => (
  <List resource="aiassistant" actions={null}>
    <DataGridExtended rowClick="edit" title={"Agents"}>
      <TextField source="name" />
      <TextField source="description" />
    </DataGridExtended>
  </List>
);

export const AIAssistantCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput label="Name" source="name" />
      <TextInput label="Description" source="description" />
    </SimpleForm>
  </Create>
);

const AssistantKeyWrapper = ({ children }) => {
  const record = useRecordContext();

  console.log('record', record);
  if (!record) return null; // or a loading spinner

  return children(record.assistantKey);
};

const EmbedCodeWrapper = ({ children }) => {
  const record = useRecordContext();

  console.log('record', record);
  if (!record) return null; // or a loading spinner

  return children(record);
};

export const AIAssistantEdit = (props) => {
  const navigate = useNavigate();


  const getNewFunction = () => {
    return {
      name: "New Function",
      id: "1",
    };
  };

  const attributes = [
    { source: "name", label: "Name" },
    { source: "description", label: "Description" },
  ];

  const InstancesTab = () => {
    const record = useRecordContext();

    if (!record) {
      // Return nothing or a loading state if the record is undefined
      return null;
    }

    return (
      <ReferenceManyField
        reference="aiassistantinstance"
        target="assistantId"
        record={{ id: record.aiassistantId }} // Override the id used in default filter
      >
        <Datagrid>
          <TextField source="name" />
        </Datagrid>
      </ReferenceManyField>
    );
  };


  return (
    <Edit {...props}>
      <>
        <Typography variant="h6" sx={{ pl: 2 }} gutterBottom>
          Agent
        </Typography>
        <TabbedForm>
          <FormTab label="General">
            <TextInput source="name" inputProps={{ size: 40 }} />
            <TextInput source="assistantKey" inputProps={{ size: 40 }} />
            <TextInput source="description" inputProps={{ size: 40 }} />
            <TextInput multiline sx={{ width: '85%' }} rows={10} label="Instructions" source="configuration.instructions" />
          </FormTab>
          <FormTab label="Files">
            <ArrayEditor
              cardLabel="File"
              source="configuration.files"
              attributes={attributes}
              EditComponent={AIFileEdit}
            />
          </FormTab>
          <FormTab label="File Stores">
            <ReferenceArrayInput
              source="configuration.fileStores"
              reference="aifilestore"
            >
              <SelectArrayInput optionText="name" />
            </ReferenceArrayInput>
          </FormTab>
          <FormTab label="Functions">
            <ArrayEditor
              cardLabel="Function"
              source="configuration.functions"
              attributes={attributes}
              getNewItem={getNewFunction}
              EditComponent={AIFunctionEdit}
            />
          </FormTab>
          <FormTab label="Test Agent">
            <AssistantKeyWrapper>
              {(assistantKey) => <ChatInterface assistantKey={assistantKey} isDrawer={false} />}
            </AssistantKeyWrapper>
          </FormTab>
          <FormTab
            label="Embed"
            sx={{
              '& .RaTabbedForm-content': {
                maxWidth: 'none',
                width: '100%'
              }
            }}
          >
            <EmbedCodeWrapper>
              {(record) => <EmbedAgent item={record} />}
            </EmbedCodeWrapper>
          </FormTab>
          <FormTab label="Instances">
            <InstancesTab />
          </FormTab>
        </TabbedForm>
      </>
    </Edit>
  );
};
